import axios, { AxiosError, AxiosResponse } from 'axios';
import { getLogger } from '../diagnostics/logger';
import { getSimManagementErrorFromAxiosError } from '.';
import { DropdownItem } from '../components/ui/input/DropdownInput';

import config from '../config';
const log = getLogger('simManagement.api.targetNetworkApi');

export interface TariffFilter {
  accountId: number;
  networkId: number;
}

export interface TargetNetwork {
  targetNetworkName: string;
}

export function getPortNetworks(networkId: number): Promise<DropdownItem[]> {
  const url = `${config.API_BASE_URL}api/network/${networkId}/targetNetwork/?select=targetNetworkName`;
  return new Promise<DropdownItem[]>((resolve, reject) => {
    axios
      .get(url)
      .then(
        (
          response: AxiosResponse<{
            count: number;
            totalCount?: number;
            result: TargetNetwork[];
          }>,
        ) => {
          const dropDownItems: DropdownItem[] = response.data.result.map((t: any) => {
            return {
              key: t.targetNetworkName,
              label: t.targetNetworkName,
            };
          });

          resolve(dropDownItems);
        },
      )
      .catch((error: any) => {
        const simManagementError = getSimManagementErrorFromAxiosError(error as AxiosError);
        log.error('Failed to load available target networks.', simManagementError);
        reject(simManagementError);
      });
  });
}
